module.exports = __webpack_public_path__ + "static/media/logo_menu.6d336348.png";